import styled from 'styled-components'

// A single, even vertical rhythm for all fields in the connect form. The shared Input already
// carries its own bottom margin, so we zero that inside a Field (below) and let this one gap own
// the spacing — otherwise the two stack and the fields sit too far apart vs the app's other forms.
export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const SectionLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.iconGray};
  /* Match the space above and below so the label doesn't sit closer to the field above it than to
     its own inputs (inside the Form the top margin offsets the parent gap for a balanced break). */
  margin-top: ${({ theme }) => theme.spacing.sm}rem;
  margin-bottom: ${({ theme }) => theme.spacing.sm}rem;
`

export const SelectedHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg}rem;
`

export const ProviderName = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.lg}rem;
  font-weight: 700;
  margin: 0;
`

export const TemplateGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

export const TemplateCard = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}rem;
  width: 100%;
  text-align: left;
  border: 1px solid ${({ theme }) => theme.colors.neutralGray};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  padding: ${({ theme }) => theme.spacing.md}rem ${({ theme }) => theme.spacing.lg}rem;
  background: ${({ theme }) => theme.colors.neutralWhite};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.defaultHover};
  }
`

export const TemplateText = styled.div`
  min-width: 0;
`

export const TemplateName = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  font-weight: 600;
`

export const AuthBadge = styled.span`
  padding: 0 ${({ theme }) => theme.spacing.xs}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ theme }) => theme.colors.neutralGray};
  color: ${({ theme }) => theme.colors.iconGrayDark};
  font-size: ${({ theme }) => theme.fontSize.xxs}rem;
  font-weight: 600;
  text-transform: uppercase;
`

export const TemplateDesc = styled.div`
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  margin-top: ${({ theme }) => theme.spacing.xxs}rem;
`

export const ExternalNote = styled.p`
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  margin: 0;
`

export const Acknowledge = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm}rem;
`

// Spacing between fields comes from the parent Form's gap, so drop the Input's own bottom margin
// (it would otherwise add to the gap and push fields too far apart).
export const Field = styled.div`
  & > div {
    margin-bottom: 0;
  }
`

export const FieldHint = styled.p`
  color: ${({ theme }) => theme.colors.iconGray};
  font-size: ${({ theme }) => theme.fontSize.xxs}rem;
  margin: ${({ theme }) => theme.spacing.xxs}rem 0 0;
`

export const CredsHelp = styled.p`
  margin: ${({ theme }) => `-${theme.spacing.xs}rem`} 0 0;
  font-size: ${({ theme }) => theme.fontSize.xs}rem;
  color: ${({ theme }) => theme.colors.iconGray};

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
